module.exports = __webpack_public_path__ + "static/media/privacy-policy.0454bcdc.png";